document.addEventListener("DOMContentLoaded", ()=>{
    MicroModal.init({
        disableFocus: true
    });
    // initialize default meeting date
    const datepickerElement = document.querySelector("#datepicker");
    let currentDate = new Date().toISOString();
    let defaultDateValue = currentDate.slice(0, 11);
    let defaultDateTime = eval(parseInt(currentDate.slice(11, 13)) + 2);
    datepickerElement.value = defaultDateValue + defaultDateTime + ":00";
    // initialize placeholder
    var date = new Date(datepickerElement.value);
    var options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    };
    var dateLisible = date.toLocaleDateString("fr-FR", options);
    document.getElementById("invisible-date").innerText = dateLisible;
    // placeholder date
    datepickerElement.addEventListener("change", (evt1)=>{
        let inputDate1 = evt1.target.value;
        var date1 = new Date(inputDate1);
        var options1 = {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        };
        var dateLisible1 = date1.toLocaleDateString("fr-FR", options1);
        evt1.target.classList.add("field-filled");
        document.getElementById("invisible-date").innerText = dateLisible1;
    });
    // placeholder ville
    const labels = document.querySelectorAll('input[name="meeting-location"] + label');
    labels.forEach((label1, index1)=>{
        label1.addEventListener("click", function(event1) {
            document.querySelectorAll('input[name="meeting-location"] + label').forEach((element1)=>{
                element1.classList.add("field-filled");
            });
            event1.preventDefault();
            let nextIndex1 = (index1 + 1) % labels.length;
            let nextRadioId1 = labels[nextIndex1].getAttribute("for");
            document.getElementById(nextRadioId1).checked = true;
        });
    });
    document.getElementById("send-mail-to-plan-net").addEventListener("click", (evt1)=>{
        let href1 = evt1.target.dataset.href + "?body=" + document.getElementById("mail-template").innerText;
        href1 = href1.replace(/(\r\n|\n|\r+)/gm, "%0D%0A").trim();
        evt1.target.classList.add("sended");
        window.location.href = href1;
    });
    wishAndHappyNewYearToDevelopers();
    onKonamiCode(function() {
        snowf.init({
            size: 5,
            amount: 150,
            dom: document.body
        });
    });
});
function wishAndHappyNewYearToDevelopers() {
    console.log("%c\u2591       \u2591\u2591\u2591      \u2591\u2591   \u2591\u2591\u2591  \u2591   \u2591\u2591\u2591  \u2591        \u2591\u2591\u2591\u2591\u2591      \u2591\u2591   \u2591\u2591\u2591  \u2591   \u2591\u2591\u2591  \u2591        \u2591        \u2591\n\u2592  \u2592\u2592\u2592\u2592  \u2592  \u2592\u2592\u2592\u2592  \u2592    \u2592\u2592  \u2592    \u2592\u2592  \u2592  \u2592\u2592\u2592\u2592\u2592\u2592\u2592\u2592\u2592\u2592  \u2592\u2592\u2592\u2592  \u2592    \u2592\u2592  \u2592    \u2592\u2592  \u2592  \u2592\u2592\u2592\u2592\u2592\u2592\u2592  \u2592\u2592\u2592\u2592\u2592\u2592\u2592\n\u2593       \u2593\u2593  \u2593\u2593\u2593\u2593  \u2593  \u2593  \u2593  \u2593  \u2593  \u2593  \u2593      \u2593\u2593\u2593\u2593\u2593\u2593  \u2593\u2593\u2593\u2593  \u2593  \u2593  \u2593  \u2593  \u2593  \u2593  \u2593      \u2593\u2593\u2593      \u2593\u2593\u2593\n\u2588  \u2588\u2588\u2588\u2588  \u2588  \u2588\u2588\u2588\u2588  \u2588  \u2588\u2588    \u2588  \u2588\u2588    \u2588  \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588        \u2588  \u2588\u2588    \u2588  \u2588\u2588    \u2588  \u2588\u2588\u2588\u2588\u2588\u2588\u2588  \u2588\u2588\u2588\u2588\u2588\u2588\u2588\n\u2588       \u2588\u2588\u2588      \u2588\u2588  \u2588\u2588\u2588   \u2588  \u2588\u2588\u2588   \u2588        \u2588\u2588\u2588\u2588  \u2588\u2588\u2588\u2588  \u2588  \u2588\u2588\u2588   \u2588  \u2588\u2588\u2588   \u2588        \u2588        \u2588\n                                                                                           ", "color:green; font-size: 10px;");
    console.log("\u0F3C \u3064 \u25D5_\u25D5 \u0F3D\u3064\uD83C\uDF6A");
}
function onKonamiCode(cb1) {
    var input1 = "";
    var key1 = "38384040373937396665";
    console.log("%c Konami Code & let it snow!", "font-weight: bold; font-size: 18px;color: red; text-shadow: 1px 1px 0 rgb(255,255,255), 2px 2px 0 rgb(0,0,0)");
    document.addEventListener("keydown", function(e1) {
        input1 += "" + e1.keyCode;
        if (input1 === key1) return cb1();
        if (!key1.indexOf(input1)) return;
        input1 = "" + e1.keyCode;
    });
}

//# sourceMappingURL=index.e9460d90.js.map
